import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Dialog, TableRow, TableCell, Tooltip, IconButton, } from "@material-ui/core";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { fillModsEditFormApi } from "../apiServices";
import moment from "moment";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ShowAttachments from "../../../../shared_elements/components/ShowAttachments";
import { dayMonthDateFormat, fieldDMYShort } from "../../../../constants";
import RevisionHistory from "../../../../shared_elements/components/RevisionHistory";
import { permissionCheckFnforCamo, checkApiStatus } from "../../../../utils";
import { globalPutService, globalDeleteService } from "../../../../utils/globalApiServices";
import { acumenCamo } from "../../../../shared_elements/components";

const ModsList = ({ item, index, toggleDelteModalFn, toggleEditModalFn, updateFormData, props, fileUploadData, currentRecordPerPage, downloadAllApi, headerTsn, headerCsn, uuid, last_used_folder_uuid, last_used_folder_uuid_link_document, checkbox_last_used_folder_uuid, getResponseBack, checkbox_last_used_folder_name, assetsDetail }) => {
	const [openGetAttachmentsDialogue, setAttachmentsDialogue] = useState(false);
	const [AllAttachmentsforDialogue, setAllAttachmentsforDialogue] = useState(null);
	const [moduleId, setmoduleId] = useState(null);
	const [lessMore, setLessMore] = useState({});

	const downAllAttach = () => {
		fillModsEditFormApi(item, props).then((response) => {
			setmoduleId(response.data.data.id);
		});
		getAttachements();
	};

	const getAttachements = () => {
		const matchingItem = assetsDetail?.list?.find(items => items?.id === item.id);
		if (!matchingItem) return [];
		const { checklist, attachments } = matchingItem || {};
		if (checklist && attachments || checklist || attachments) {
			const { files, folders } = checklist || {};
			if (attachments?.length > 0 && files?.length > 0 && folders?.length > 0) {
				getAttachments([...attachments, ...files, ...folders])
			} else if (files?.length > 0 && folders?.length > 0) {
				getAttachments([...folders, ...files])
			} else if (attachments?.length > 0 && files?.length > 0) {
				getAttachments([...attachments, ...files])
			} else if (attachments?.length > 0 && folders?.length > 0) {
				getAttachments([...attachments, ...folders])
			} else if (attachments?.length > 0) {
				getAttachments([...attachments])
			} else if (folders?.length > 0) {
				getAttachments([...folders])
			} else if (files?.length > 0) {
				getAttachments([...files])
			}
		}
		return [];
	};

	const openAttachment = (file) => {
		var decodedURL = decodeURIComponent(file);
		window.open(decodedURL, "_blank");
	};

	const formatDate = (date) => {
		return moment(date).format("DD-MM-YYYY");
	};

	const getAttachments = (attachments) => {
		setAllAttachmentsforDialogue(attachments);
		setAttachmentsDialogue(true);
	};

	const handleCloseAttachmentDialogue = () => {
		setAttachmentsDialogue(false);
	};

	const convertToDate = (value) => {
		if (typeof value === "string") {
			return formatDate(value);
		} else if (typeof value === "number") {
			return value;
		} else {
			return "--";
		}
	};

	let timezone = moment().format()
	const timestamp = Math.floor(Date.now() / 1000);
	const modsurl = `audit/camo/modstatus/?object_id=${item.id}&action=0,1&timezone=${timezone}&timestamp=${timestamp}`

	const removeAttachment = (item, checklist, fileId, uuid) => {
		if (uuid) {
			let payload = {};
			payload.delete = true;
			payload.folder_ids = checklist.filter(items => items.type === 'folder').map(file => file.id).filter((id) => id !== fileId).toString()
			payload.file_ids = checklist.filter(items => items.type === 'file').map(file => file.id).filter((id) => id !== fileId).toString()
			globalPutService(`camo/mods/${item?.id}/document-checklists/`, payload)
				.then((response) => {
					if (checkApiStatus(response)) {
						fillModsEditFormApi(item, props).then((response) => {
							const matchingItem = response.data.data;
							if (!matchingItem) return [];
							const { checklist, attachments } = matchingItem || {};
							if (checklist && attachments || checklist || attachments) {
								if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0 && item?.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data?.data?.checklist?.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response?.data?.data?.checklist?.files])
								} else if (item.checklist?.files?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0) {
									getAttachments([...response.data.data.attachments])
								} else if (item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.folders])
								} else if (item.checklist?.files?.length > 0) {
									getAttachments([...response?.data?.data?.checklist?.files])
								}
								getResponseBack()
							}
							return [];
						});
					}
				})
		} else {
			globalDeleteService(`camo/attachment/${fileId}/delete/`).then((response) => {
				if (response.status === 500) {
					props.enqueueSnackbar("Something went wrong.", {
						variant: "error",
						anchorOrigin: { vertical: "top", horizontal: "right" },
					});
				} else {
					if (response) {
						fillModsEditFormApi(item, props).then((response) => {
							const matchingItem = response.data.data;
							if (!matchingItem) return [];
							const { checklist, attachments } = matchingItem || {};
							if (checklist && attachments || checklist || attachments) {
								if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0 && item?.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data?.data?.checklist?.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0 && item.checklist?.files?.length > 0) {
									getAttachments([...response.data.data.attachments, ...response?.data?.data?.checklist?.files])
								} else if (item.checklist?.files?.length > 0 && item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.files, ...response.data.data.checklist.folders])
								} else if (item?.attachments?.length > 0) {
									getAttachments([...response.data.data.attachments])
								} else if (item.checklist?.folders?.length > 0) {
									getAttachments([...response.data.data.checklist.folders])
								} else if (item.checklist?.files?.length > 0) {
									getAttachments([...response?.data?.data?.checklist?.files])
								}
								getResponseBack()
							}
							return [];
						});
					}
				}
			});
		}
	};

	function getAttachmentCount(item) {
		const { attachments, checklist } = item;
		const { files, folders } = checklist || {};

		const attachmentCount = attachments?.length || 0;
		const fileCount = files?.length || 0;
		const folderCount = folders?.length || 0;

		if (attachmentCount && fileCount && folderCount) {
			return attachmentCount + fileCount + folderCount;
		} else if (fileCount && folderCount) {
			return fileCount + folderCount;
		} else if (attachmentCount && folderCount) {
			return attachmentCount + folderCount;
		} else if (attachmentCount && fileCount) {
			return attachmentCount + fileCount;
		} else {
			return folderCount || fileCount || attachmentCount || '--';
		}
	}
	const attachmentCount = getAttachmentCount(item);

	const toggleLessMore = (lessMr) => {
		setLessMore({
			...lessMore,
			[lessMr]: !lessMore[lessMr]
		});
	}

	const lessMoreFn = (name, lessMr) => {
		return <>
			{name && name?.length > 35 ? (
				<>
					{lessMore[lessMr] ?
						(<> {name} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..less </span> </>)
						:
						(<>{name.substring(0, 35)} <span style={{ color: "#0e7fe1" }} onClick={(e) => { e.preventDefault(); toggleLessMore(lessMr); }}  > ..more </span> </>)
					}
				</>
			) : name || '--'
			}
		</>
	}

	return (
		<>
			<TableRow
				hover
				tabIndex={-1}
				style={{ cursor: "pointer" }}
				className="engine-module-table"
			>
				<TableCell>
					<div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
						{permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "U", }) ? (
							<Tooltip title="Edit" arrow placement="top">
								<CreateOutlinedIcon color="primary" className="amp-table__edit-icon" onClick={(e) => { toggleEditModalFn(e,item) }} />
							</Tooltip>
						) : null}
						{permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "D", }) ||
							permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "OD", userId: item.created_by, }) ? (
							<Tooltip title="Delete" arrow placement="top">
								<DeleteOutlinedIcon color="secondary" className="amp-table__delete-icon" onClick={toggleDelteModalFn} />
							</Tooltip>
						) : null}
						<RevisionHistory buttonType={true} url={modsurl} />
					</div>
				</TableCell>
				<TableCell>{item.ata_chapter ? item.ata_chapter : "--"}</TableCell>
				<TableCell> {item.mod_ref_number ? item.mod_ref_number : "--"} </TableCell>
				<TableCell>{item.mod_issued_by ? item.mod_issued_by : "--"}</TableCell>
				<TableCell> {item.mod_applicability ? item.mod_applicability : "--"} </TableCell>
				<TableCell>{lessMoreFn(item?.description, "description")}</TableCell>
				<TableCell>{item.type ? item.type : "--"}</TableCell>
				<TableCell>{item.effectivity ? item.effectivity : "--"}</TableCell>
				<TableCell> {item.effectivity_date ? moment(item.effectivity_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"} </TableCell>
				<TableCell> {item.mod_interval_type ? item.mod_interval_type : "--"} </TableCell>
				<TableCell>{item.mod_interval ? item.mod_interval : "--"}</TableCell>
				<TableCell> {item.mod_compliance_status ? item.mod_compliance_status : "--"} </TableCell>
				<TableCell> {item.mod_compliance_tsn ? item.mod_compliance_tsn : "--"} </TableCell>
				<TableCell> {item.mod_compliance_csn ? item.mod_compliance_csn : "--"} </TableCell>
				<TableCell> {item.mod_compliance_date ? moment(item.mod_compliance_date).format(acumenCamo ? fieldDMYShort : dayMonthDateFormat) : "--"} </TableCell>
				<TableCell>{convertToDate(item?.remaining?.due_at)}</TableCell>
				<TableCell>
					{attachmentCount ? (
						<>
							<Tooltip title="View Attachments">
								<span className="center" onClick={() => downAllAttach()} >
									<AttachFileIcon className="attach-icon" />
									<a href="#" style={{ color: "#0e7fe1" }}>{attachmentCount}</a>
								</span>
							</Tooltip>
						</>
					) : (
						"--"
					)}
				</TableCell>
			</TableRow>

			<Dialog
				open={openGetAttachmentsDialogue}
				onClose={handleCloseAttachmentDialogue}
				id="htDialog"
			>
				<ShowAttachments
					handleClose={() => handleCloseAttachmentDialogue()}
					handleShowAttachments={AllAttachmentsforDialogue}
					openAttachment={openAttachment}
					files={{ title: "MODs", extension: "zip", key: "" }}
					downloadAllApi={downloadAllApi}
					moduleId={moduleId}
					item={item}
					removeAttachment={removeAttachment}
				/>
			</Dialog>
		</>
	);
};

export default withRouter(ModsList);
